'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import type { ModalProps } from '@repo/design-system/components/ui/modal';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId, selectTitleId } from '@repo/store/maps/slices/mapData';
import { Link } from '@repo/ui/components/link/link';
import type React from 'react';
import { useMapDownloadPath } from '../utils/use-map-download-path';
import { WandExperienceModal } from './wand-experience-modal';
interface MarkFoundDownloadModalProps extends ModalProps {
  onDownloadClick: () => void;
}
export const MarkFoundDownloadModal: React.FC<MarkFoundDownloadModalProps> = t0 => {
  const $ = _c(20);
  let onDownloadClick;
  let props;
  if ($[0] !== t0) {
    ({
      onDownloadClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onDownloadClick;
    $[2] = props;
  } else {
    onDownloadClick = $[1];
    props = $[2];
  }
  const titleId = useAppSelector(selectTitleId);
  const mapId = useAppSelector(selectExternalMapId);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[4] !== mapId || $[5] !== titleId) {
    t2 = {
      mapId,
      titleId
    };
    $[4] = mapId;
    $[5] = titleId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const downloadPath = useMapDownloadPath("mark_found_modal", t2);
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      display: "block",
      width: "full"
    });
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon icon="download" decorative={true} />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Button color="brand" size="lg" fullWidth={true}>{t4}{t5}</Button>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== downloadPath || $[14] !== onDownloadClick || $[15] !== t6) {
    t7 = <Link href={downloadPath} onClick={onDownloadClick} className={t3}>{t6}</Link>;
    $[13] = downloadPath;
    $[14] = onDownloadClick;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== props || $[18] !== t7) {
    t8 = <WandExperienceModal {...props} cta={t7} />;
    $[17] = props;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
function _temp($) {
  return $.mark_found_download_prompt.download_wand_to_mark_as_found;
}